import { render, staticRenderFns } from "./RecurrenceSelector.vue?vue&type=template&id=473e1e90&scoped=true&"
import script from "./RecurrenceSelector.vue?vue&type=script&lang=ts&"
export * from "./RecurrenceSelector.vue?vue&type=script&lang=ts&"
import style0 from "./RecurrenceSelector.vue?vue&type=style&index=0&id=473e1e90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473e1e90",
  null
  
)

export default component.exports